import preact, {Component, h, ComponentChild} from 'preact'
import Panel from '../panel'
import InputGroup from '../ui-components/InputGroup'
import {GroupData, ImageData} from './Overview'
import ImageUploader from '../category/control/ImageUploader'
import Button from '../ui-components/Button'
import Editor from '../editor'

interface Props extends GroupData {
  titleError?: string,
  descriptionError?: string,
  updateTitle: (title: string) => void,
  updateDescription: (description: string) => void,
  updateHeroImage: (heroImage: null | ImageData) => void
  updateThumbnailImage: (heroImage: null | ImageData) => void
}

interface ImageInputProps {
  width: number,
  height: number,
  label: string,
  dimensionText: string,
  description: ComponentChild,
  className: string,
  image: ImageData | null,
  updateImage: (heroImage: null | ImageData) => void
}

class GroupImageInput extends Component<ImageInputProps> {
  uploader: preact.RefObject

  render({
    width,
    height,
    className,
    dimensionText,
    label,
    description,
    image,
    updateImage
  }: ImageInputProps) {
    return <div className={className}>
      <label>{label}</label>
      <p>{description}</p>
      {
        image ? (
          <div className='hero-image-container'>
            <div className='hero-image-wrapper'>
              <img src={image.source_thumb} />
              <a target='_blank' href={image.source_thumb} className='component-uploader__image-details'>
                {dimensionText} <i className='icon icon-external' />
              </a>
            </div>
            <div className='hero-image_buttons'>
              <Button
                type='button'
                class='btn-default btn--insided-secondary-brand'
                onClick={() => this.uploader.click()}
              >
                Edit
              </Button>
              <Button
                type='button'
                class='btn-default btn--insided-secondary-brand btn-delete'
                onClick={() => updateImage(null)}
              >
                Remove
              </Button>
            </div>
          </div>
        ) : (
          <div>
            <Button
              type='button'
              class='btn-default'
              onClick={() => this.uploader.click()}
            >
              Upload image
            </Button>
          </div>
        )
      }
      <ImageUploader
        width={width}
        height={height}
        onUploaded={(data: ImageData) => updateImage(data)}
        uploaderRef={(ref: preact.RefObject) => {
          this.uploader = ref
        }}
      />
    </div>
  }
}

export class GroupInfoPanel extends Component<Props> {
  render({
    title,
    updateTitle,
    description,
    updateDescription,
    heroImage,
    updateHeroImage,
    thumbnailImage,
    updateThumbnailImage,
    titleError,
    descriptionError
  }: Props) {
    return (
      <Panel title='Group details'>
        <InputGroup
          title='Group name'
          type='text'
          error={titleError}
          placeholder='Add a name'
          onChange={(e: {target: HTMLInputElement}) => updateTitle(e.target.value)}
          value={title} />

        <div className={`group-page_description ${descriptionError ? 'error' : ''}`}>
          <label>About this group</label>
          <Editor
            isControl
            data={description}
            CKEditor={false}
            canHavePoll={false}
            onChange={(content: string) => {
              updateDescription(content)
            }} />
          {
            descriptionError ? <p className='error'> {descriptionError} </p> : null
          }
        </div>

        <GroupImageInput
          className='group-page_hero'
          image={heroImage}
          updateImage={updateHeroImage}
          label='Hero image'
          description={<p>Hero image will be shown on top of the group page <br />
            Maximum file size: 5MB. Allowed image types: .jpg, .png, .gif. We recommend a minimum of 2880*480px </p>}
          dimensionText='2880 × 480px'
          width={2880}
          height={480}
        />

        <br/>

        <GroupImageInput
          className='group-page_hero'
          image={thumbnailImage}
          updateImage={updateThumbnailImage}
          label='Thumbnail image'
          description={<p>Thumbnail will be shown a group overview page <br />
            Maximum file size: 5MB. Allowed image types: .jpg, .png, .gif.</p>}
          dimensionText=''
          width={600}
          height={320}
        />
      </Panel>
    )
  }
}

export default GroupInfoPanel
